import React, {useState, useContext} from "react"
import {AssociateFilterContext} from "./context/AssociateFilterContext";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Link from "@amzn/meridian/link";
import Tag from "@amzn/meridian/tag";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import Column from "@amzn/meridian/column";
import {FormattedMessage, injectIntl} from "react-intl";

const AssociateFilter = ({ intl }) => {
    const {states, dispatch} = useContext(AssociateFilterContext)
    const [ filterState, setFilterState ] = useState(false);

    const toggleFilter = () => {
        setFilterState(!filterState);
    };

    return (
        <Column>
            <Row width="100%" spacingInset="large large none large">
                <Box>
                    <Link href="" type="secondary" onClick={toggleFilter}>
                        <FormattedMessage id="associate.option" defaultMessage="Options"/>
                    </Link>
                </Box>
                <Box>
                    <div className="filter-tag">
                        {states.map(state => {
                            return <Tag key = {state}
                                        onClose={() => dispatch({ type: 'REMOVE_STATE', state})}
                                        type="neutral">{state}</Tag>
                        })}
                    </div>
                </Box>
            </Row>
            {filterState ? <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                <ControlGroup
                    label={intl.formatMessage({id: 'associate.active'})}
                    name="state"
                    onChange={(data) => dispatch({ type: 'SELECT_STATE', state: data })}
                    value={states}>
                    <Checkbox key="yes" value="Yes">Yes</Checkbox>
                    <Checkbox key="no" value="No">No</Checkbox>
                </ControlGroup>
            </Row> : null}
        </Column>
    )
}

export default injectIntl(AssociateFilter)


// WEBPACK FOOTER //
// ./src/components/associate/AssociateFilter.js